import React from 'react';

/**
 * Normal Loading Page component
 * This is shown during the initial config fetch.
 */
const LoadingPage = () => {
    return (
        <div style={{ 
            height: '100vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            flexDirection: 'column',
            fontFamily: '"Inter", sans-serif',
            background: '#f8fafc',
            color: '#1e293b'
        }}>
            <style>
                {`
                .loader-spinner {
                    width: 48px;
                    height: 48px;
                    border: 5px solid #e2e8f0;
                    border-bottom-color: #3b82f6;
                    border-radius: 50%;
                    display: inline-block;
                    box-sizing: border-box;
                    animation: rotation 1s linear infinite;
                }

                @keyframes rotation {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
            </style>
            <span className="loader-spinner"></span>
            <p style={{ marginTop: '20px', fontSize: '1.1rem', fontWeight: '500' }}>
                Loading application...
            </p>
        </div>
    );
};

export default LoadingPage;
